/* import __COLOCATED_TEMPLATE__ from './changelog-display.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();